var path = '/templates/projects.settings/users/internal_user_table.html';
var html = "<section ng-if=!vm.isCommonUser><h1 class=config-title><i class=\"fa fa-lock\"></i> {{ 'projectsSettings.users.internalUsers' | translate }}</h1><table class=\"table config-table table-bordered\"><tr><th>{{ 'projectsSettings.users.menbaa_na' | translate }}</th><th>{{ 'projectsSettings.users.meeruadoresu' | translate }}</th></tr><tr ng-repeat=\"user in vm.internalUsers\"><td>{{ user.full_name }}</td><td>{{ user.email }}</td></tr></table></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.settings/users/internal_user_table.html
// module id = 1534
// module chunks = 0